import { BASE_API_URL, BASE_NEW_API_URL } from '@/constants';
import { ApiUrls } from '@/services/pluginsManager/pluginsManager.types';

export const getApiUrls = (): ApiUrls => ({
  baseApiUrl: BASE_API_URL,
  baseNewApiUrl: BASE_NEW_API_URL,
});
